import ElementPlus from 'element-plus'
import locale from 'element-plus/dist/locale/ru.mjs'

export default (app) => {
  app.use(ElementPlus, { locale })
}
